import React from "react";
import { AppComponent } from "../shared-components/AppComponent";
import type { IAppLegal } from "./AppLegal";
import { ImpressumComponent } from "./impressum/ImpressumComponent";
import { ResponsibleDisclosureComponent } from "./responsible-disclosure/ResponsibleDisclosureComponent";
import { PrivacyPolicyComponent } from "./privacy/PrivacyPolicyComponent";
import { CookiePolicyComponent } from "./cookie/CookiePolicyComponent";

interface ILegalMasterMasterComponentProps {
    appLegal: IAppLegal;
}

export class LegalMasterComponent extends React.Component<ILegalMasterMasterComponentProps> {
    render() {
        const { appLegal } = this.props;
        const { stores } = appLegal;

        return (
            <AppComponent appStores={stores}>
                <div id={"legal-master-component"}>
                    <PrivacyPolicyComponent />
                    <CookiePolicyComponent />
                    <ResponsibleDisclosureComponent />
                    <ImpressumComponent />
                </div>
            </AppComponent>
        );
    }
}
